import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="suggestions-intro"]' },
  { target: '[data-tour="suggestions-filters"]' },
  { target: '[data-tour="suggestions-list"]', spotlightChildCount: 3 },
  { target: '[data-tour="suggestions-detail"]' }
];

export const FAMILY_MY_SUGGESTIONS_TOUR_STEPS: TourStep[] = buildTourSteps('familyMySuggestions', STEP_DEFS);

export const FAMILY_MY_SUGGESTIONS_TOUR_STORAGE_KEY = 'wetree-family-my-suggestions-tour-completed';

export function resolveFamilyMySuggestionsTourSteps(steps: TourStep[], hasSuggestions: boolean): TourStep[] {
  if (hasSuggestions) {
    return steps;
  }
  return steps.filter(
    (step) => step.target !== '[data-tour="suggestions-list"]' && step.target !== '[data-tour="suggestions-detail"]'
  );
}
